import { useState } from "react";
import { Phone, Info } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { useAuth } from "../../context/AuthContext";

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.3 0-9.7-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

export const LoginPanel = () => {
  const { t } = useLang();
  const { login } = useAuth();
  const [phone, setPhone] = useState("");
  const [msg, setMsg] = useState(false);

  const submitPhone = (e) => {
    e.preventDefault();
    setMsg(true);
  };

  return (
    <div data-testid="login-panel" className="w-full max-w-md border border-sand bg-white/60 p-7 sm:p-10">
      <h2 className="font-display text-3xl">{t("login_title")}</h2>
      <p className="mt-2 text-sm leading-7 text-ink/60">{t("login_desc")}</p>

      <form onSubmit={submitPhone} className="mt-8">
        <label className="text-xs tracking-[0.08em] text-sand-dark">{t("phone")}</label>
        <div className="mt-1 flex items-center gap-2 border-b border-sand focus-within:border-gold">
          <Phone size={16} strokeWidth={1.4} className="text-sand-dark" />
          <input data-testid="phone-login-input" type="tel" inputMode="tel" dir="ltr" placeholder="05XXXXXXXX" value={phone}
            onChange={(e) => { setPhone(e.target.value); setMsg(false); }} className="w-full bg-transparent py-3 text-base outline-none placeholder:text-sand-dark" />
        </div>
        <button data-testid="phone-login-submit" className="btn-ink mt-5 w-full">{t("send_code")}</button>
        {msg && (
          <p data-testid="phone-login-unavailable" role="alert" className="mt-4 flex items-start gap-2 bg-sand-light p-3 text-sm leading-6">
            <Info size={16} strokeWidth={1.5} className="mt-1 shrink-0 text-gold-deep" />{t("phone_unavailable")}
          </p>
        )}
      </form>

      <div className="my-7 flex items-center gap-4 text-xs text-ink/50"><span className="h-px flex-1 bg-sand" />{t("or")}<span className="h-px flex-1 bg-sand" /></div>

      <button data-testid="google-login-button" onClick={login}
        className="flex w-full items-center justify-center gap-3 border border-ink bg-white py-4 text-sm tracking-[0.06em] transition-colors duration-300 hover:bg-sand-light">
        <GoogleIcon />{t("login_google")}
      </button>
      <p className="mt-6 text-center text-xs text-ink/50">{t("guest_note")}</p>
    </div>
  );
};
